var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-item",on:{"click":_vm.onClick}},[(_vm.item.title == _vm.activeItem)?_c('el-button',{attrs:{"type":"primary","size":"mini"}},[_vm._v(_vm._s(_vm.item.title))]):_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.item.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/practice/code/navbar-item.vue?vue&type=template&id=99f3e548&scoped=true
// module id = null
// module chunks = 